(() => {
 const roots = document.querySelectorAll('.vx-project-technical');
 if (!roots.length || !window.matchMedia) return;
 const media = window.matchMedia('(max-width: 700px)');
 const setup = root => {
   const panels = root.querySelectorAll('[data-vx-mobile-collapse]');
   panels.forEach(panel => { panel.open = !media.matches; });
 };
 roots.forEach(setup);
 const update = () => document.querySelectorAll('.vx-project-technical').forEach(setup);
 media.addEventListener('change', update);
 document.addEventListener('shopify:section:load', event => {
   event.target.querySelectorAll('.vx-project-technical').forEach(setup);
 });
 // Reveal a folded ancestor if a direct link points inside it.
 const revealAnchor = () => {
   if (!location.hash) return;
   let target;
   try { target = document.getElementById(decodeURIComponent(location.hash.slice(1))); } catch (_) { return; }
   if (!target || !target.closest('.vx-project-technical')) return;
   let panel = target.closest('details');
   while (panel) { panel.open = true; panel = panel.parentElement.closest('details'); }
 };
 window.addEventListener('hashchange', revealAnchor);
 revealAnchor();
})();
